const open_agent = {
    page_title: 'Agent identities',
    title: 'Agent identities',
    subtitle: 'Register and govern autonomous agents. Approval requires proof of key possession.',
    register: 'Register agent',
    search: 'Search agents',
    empty: 'No agent identities yet.',
    agent: 'Agent and purpose',
    readiness: 'Readiness',
    status: 'Status',
    last_activity: 'Last activity',
    unverified: 'Needs review',
    active: 'Operational',
    suspended: 'Suspended',
    details: 'Agent readiness',
    details_subtitle: 'Credentials, authority, and recent security activity.',
    approve: 'Approve agent',
    suspend: 'Suspend agent',
    create_title: 'Register agent',
    create_subtitle: 'Creation grants no authority. Approval follows successful key proof.',
    name: 'Agent name',
    purpose: 'Purpose',
    email: 'OpenAgent email',
    controller: 'Controller ID',
    algorithm: 'Signing algorithm',
    public_key: 'Public JWK',
    invalid_jwk: 'Enter a valid JSON Web Key.',
    continue: 'Create registration',
    challenge: 'Proof of possession',
    challenge_subtitle: 'Sign the exact challenge message with the agent private key.',
    challenge_id: 'Challenge ID',
    nonce: 'Nonce',
    signature: 'Signature (base64url)',
    verify: 'Verify signature',
    verified: 'Key possession verified.',
    keys: 'Public keys',
    authority: 'Authorized services',
    workers: 'OpenAgent Workers',
    connect_workers: 'Connect Workers',
    approve_workers: 'Approve Workers access',
    revoke_workers: 'Revoke Workers access',
    no_services: 'No services are authorized for this agent.',
    activity: 'Recent activity',
};
export default Object.freeze(open_agent);
